import "./index.less";
import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";
import OrderItemDisplay from "./OrderItemDisplay";
import { isEmpty } from "@/utils";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import NewOrderItemDisplayType from "@/scenes/OrderManagement/enum/NewOrderItemDisplayType";
import { observer } from "mobx-react-lite";

interface NewOrderItemsColumnProps {
    order: OrderDTO;

    shopType: ShopType;
}

const NewOrderItemsColumn: React.FC<NewOrderItemsColumnProps> = function (props) {
    const { order, shopType } = props;
    const orderStatus = order.status;
    const orderItems = order.orderItems;
    const shopId = order.shopId;
    const hasAbnormal = !isEmpty(order.abnormalCause);
    const orderManagementStore = useOrderManagementStore();
    const orderItemColumnSetting = orderManagementStore.storage.orderItemColumnSetting;

    const displayConfig = {
        showGift: orderItemColumnSetting.orderItemDisplayData[NewOrderItemDisplayType.GIFT],
        maxDisplayOrderItemCount: orderItemColumnSetting.maxDisplayOrderItemCount,
        selectedOrderItemDisplayTypesWithOutGiftTypes:
            orderItemColumnSetting.selectedOrderItemDisplayTypesWithOutGiftTypes,
        picSize: orderItemColumnSetting.picSize,
    };

    if (!orderItems || orderItems.length === 0) {
        return <td></td>;
    }

    return (
        <td>
            <OrderItemDisplay
                orderItems={orderItems}
                shopType={shopType}
                orderStatus={orderStatus}
                shopId={shopId}
                hasAbnormal={hasAbnormal}
                displayConfig={displayConfig}
            />
        </td>
    );
};

export default observer(NewOrderItemsColumn);
